import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

import {getPhoneDataFromString} from "@pg-mono/string-utils";

import {addNotification} from "@/features/notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "@/features/notifications/utils/error_notifications";
import {useAppDispatch} from "@/store/hooks/use_app_dispatch";

import {useGetUserProfileQuery, usePatchAccountDetailsMutation} from "../api/user_api";
import {PHONE_NUMBER_FORM_CONTENT} from "../constants/user_content";
import {hasPhoneError} from "../utils/hasPhoneError";

export const POLAND_PHONE_CODE = [{label: "PL", value: 48}];

export interface IPhoneNumberFormData {
    phone: {
        code: number;
        number: string;
    };
}

const validationSchema = Yup.object().shape({
    phone: Yup.object().shape({
        code: Yup.number().required(),
        number: Yup.string()
            .required()
            .matches(/^\d+$/, PHONE_NUMBER_FORM_CONTENT.INVALID_FORMAT)
            .min(9, PHONE_NUMBER_FORM_CONTENT.LENGTH_ERROR)
            .max(9, PHONE_NUMBER_FORM_CONTENT.LENGTH_ERROR)
    })
});

interface IProps {
    onPhoneNumberSaved: (savedPhone: string) => void;
}

/** Shared validation + save flow behind every "enter your phone number" form (dashboard prompt, onboarding modal, …). */
export const usePhoneNumberPatchForm = (props: IProps) => {
    const {onPhoneNumberSaved} = props;

    const dispatch = useAppDispatch();
    const [patchAccountDetails] = usePatchAccountDetailsMutation();
    const {data: userProfile} = useGetUserProfileQuery();

    const form = useForm<IPhoneNumberFormData>({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        defaultValues: {
            phone: getPhoneDataFromString()
        },
        values: userProfile ? {phone: getPhoneDataFromString(userProfile.phone ?? undefined)} : undefined
    });

    const onSubmit = form.handleSubmit(async (values) => {
        const response = await patchAccountDetails({phone: `${values.phone.code} ${values.phone.number}`});

        if (response.error && hasPhoneError(response.error)) {
            dispatch(addNotification(defaultAPIErrorNotification));
            form.setError("phone.number", {type: "server", message: response.error.data.phone[0]});
            return;
        }

        if (response.error && !("data" in response.error)) {
            form.setError("phone.number", {type: "server", message: PHONE_NUMBER_FORM_CONTENT.GENERIC_ERROR});
            return;
        }

        onPhoneNumberSaved(`${values.phone.code} ${values.phone.number}`);
    });

    return {
        form,
        isSubmitting: form.formState.isSubmitting,
        onSubmit
    };
};
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

import {getPhoneDataFromString} from "@pg-mono/string-utils";

import {addNotification} from "@/features/notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "@/features/notifications/utils/error_notifications";
import {useAppDispatch} from "@/store/hooks/use_app_dispatch";

import {useGetUserProfileQuery, usePatchAccountDetailsMutation} from "../api/user_api";
import {PHONE_NUMBER_FORM_CONTENT} from "../constants/user_content";
import {hasPhoneError} from "../utils/hasPhoneError";

export const POLAND_PHONE_CODE = [{label: "PL", value: 48}];

export interface IPhoneNumberFormData {
    phone: {
        code: number;
        number: string;
    };
}

const validationSchema = Yup.object().shape({
    phone: Yup.object().shape({
        code: Yup.number().required(),
        number: Yup.string()
            .required()
            .matches(/^\d+$/, PHONE_NUMBER_FORM_CONTENT.INVALID_FORMAT)
            .min(9, PHONE_NUMBER_FORM_CONTENT.LENGTH_ERROR)
            .max(9, PHONE_NUMBER_FORM_CONTENT.LENGTH_ERROR)
    })
});

interface IProps {
    onPhoneNumberSaved: (savedPhone: string) => void;
}

/** Shared validation + save flow behind every "enter your phone number" form (dashboard prompt, onboarding modal, …). */
export const usePhoneNumberPatchForm = (props: IProps) => {
    const {onPhoneNumberSaved} = props;

    const dispatch = useAppDispatch();
    const [patchAccountDetails] = usePatchAccountDetailsMutation();
    const {data: userProfile} = useGetUserProfileQuery();

    const form = useForm<IPhoneNumberFormData>({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        defaultValues: {
            phone: getPhoneDataFromString()
        },
        values: userProfile ? {phone: getPhoneDataFromString(userProfile.phone ?? undefined)} : undefined
    });

    const onSubmit = form.handleSubmit(async (values) => {
        const response = await patchAccountDetails({phone: `${values.phone.code} ${values.phone.number}`});

        if (response.error && hasPhoneError(response.error)) {
            dispatch(addNotification(defaultAPIErrorNotification));
            form.setError("phone.number", {type: "server", message: response.error.data.phone[0]});
            return;
        }

        if (response.error && !("data" in response.error)) {
            form.setError("phone.number", {type: "server", message: PHONE_NUMBER_FORM_CONTENT.GENERIC_ERROR});
            return;
        }

        onPhoneNumberSaved(`${values.phone.code} ${values.phone.number}`);
    });

    return {
        form,
        isSubmitting: form.formState.isSubmitting,
        onSubmit
    };
};
